import React from "react";
import { node } from "prop-types";
import ComponentsContainer from "../../components/ComponentsContainer";

const Background = ({ children }) => {
  return (
    <ComponentsContainer
      sx={{
        height: "100vh",
        width: "100vw",
        textAlign: "center",
        overflow: "hidden",
        background: "#163d85",
        paddingTop: "50px !important",
      }}
    >
      {children}
    </ComponentsContainer>
  );
};

Background.propTypes = {
  children: node.isRequired,
};

export default Background;
